export default "__VITE_ASSET__DrWjzvda__"